import React, { useEffect, useRef } from "react";
import image1 from "../../src/images/etsimage.PNG";
import image2 from "../../src/images/etsimage2.PNG";
import { useAnimation, useInView, motion } from "framer-motion";

const Features = () => {
  const { innerWidth: width } = window;
  const ref = useRef(null);
  const isInView = useInView(ref);

  const mainControlls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControlls.start("visible");
    }
  }, [isInView, mainControlls]);
  return (
    <>
      <div className="w-[70%] h-[2px] bg-gradient-to-r from-blue-400 to-violet-500"></div>
      <div className="max-w-screen overflow-x-hidden font-poppins">
        {/* features section */}
        {width < 631 ? (
          <>
            <section className="text-black bg-gradient-to-r from-blue-50 to-violet-50 py-12">
              <div className="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl shadow-lg rounded-lg">

                <div>
                  <h2 className="text-3xl font-bold tracking-tight text-center sm:text-5xl text-blue-600">
                    Pourquoi choisir nos produits ?
                  </h2>
                  <p className="max-w-3xl mx-auto mt-4 text-xl text-center text-gray-700">
                    Les produits solaires de ETS ROSE transforment la vie des familles en leur offrant un accès à une énergie propre, fiable et abordable.
                  </p>
                </div>
                <div className="grid lg:gap-6 lg:grid-cols-2 lg:items-center">

                  <div className="mt-4 space-y-12">
                    <div className="flex">
                      <div className="ml-4">
                        <p className="mt-2 text-gray-600">
                          🌍 Une source de lumière indispensable Grâce à nos kits solaires, les foyers autrefois plongés dans l’obscurité disposent désormais d’un éclairage sûr et durable. Que ce soit pour permettre aux enfants d’étudier le soir, aux familles de cuisiner en toute tranquillité ou aux commerçants de prolonger leur activité, nos solutions apportent un véritable changement.
                        </p>
                        <p className="mt-2 text-gray-600">
                          ⚡ Une autonomie énergétique accessible à tous Nos lampes solaires sont faciles à installer et à utiliser. Comme illustré dans les images, elles fonctionnent sans électricité, avec une simple recharge solaire, offrant ainsi une indépendance énergétique totale, même dans les zones les plus reculées.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div aria-hidden="true" className="mt-10 lg:mt-0">
                      <img
                        src={image1}
                        alt="image1"
                        className="taos:translate-x-[200px] taos:opacity-0 hover:-translate-y-2 transition ease-in-out duration-300 hover:drop-shadow-xl mx-auto rounded-lg shadow-lg dark:bg-gray-500 border-4 border-blue-200"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
                    <div className="lg:col-start-2">
                      <div className="mt-12 space-y-12">
                        <motion.div
                          ref={ref}
                          variants={{
                            hidden: { opacity: 0, y: -75 },
                            visible: { opacity: 1, y: 0 },
                          }}
                          initial="hidden"
                          animate={mainControlls}
                          transition={{ duration: 0.5, delay: 0.55 }}
                          className="flex"
                        >
                          <div className="ml-4">
                            <p className="mt-2 text-gray-600">
                              💡 Économie et durabilité
                              Nos foyers améliorés réduisent de plus de 30 % la consommation de combustibles, tandis que nos kits solaires certifiés VERASOL sont garantis 24 mois, assurant une performance fiable et durable.
                            </p>
                            <p className="mt-2 text-gray-600">
                              ✅ Un engagement pour un avenir plus vert
                              En choisissant ETS ROSE, vous participez à la préservation de l’environnement tout en améliorant votre quotidien. Moins de bougies, moins de kérosène, plus de sécurité et un impact positif sur la planète !
                            </p>
                          </div>
                        </motion.div>
                      </div>
                    </div>
                    <div className="mt-10 lg:mt-0 lg:col-start-1 lg:row-start-1">
                      <img
                        src={image2}
                        alt="image2"
                        className="taos:translate-x-[200px] taos:opacity-0 hover:-translate-y-2 transition ease-in-out duration-300 hover:drop-shadow-xl mx-auto rounded-lg shadow-lg dark:bg-gray-500 border-4 border-blue-200"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          <>
            <section className="text-black bg-gradient-to-r from-blue-50 to-violet-50 py-12">
              <div className="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl shadow-lg rounded-lg">
                <div>
                  <h2 className="text-3xl font-bold tracking-tight text-center sm:text-5xl text-blue-600">
                    Pourquoi choisir nos produits ?
                  </h2>
                  <p className="max-w-3xl mx-auto mt-4 text-xl text-center text-gray-700">
                    Les produits solaires de ETS ROSE transforment la vie des familles en leur offrant un accès à une énergie propre, fiable et abordable.
                  </p>
                </div>
                <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">

                  <div className="mt-12 space-y-12">
                    <motion.div
                      ref={ref}
                      variants={{
                        hidden: { opacity: 0, y: 75 },
                        visible: { opacity: 1, y: 0 },
                      }}
                      initial="hidden"
                      animate={mainControlls}
                      transition={{ duration: 0.5, delay: 0.55 }}
                      className="flex"
                    >
                      <div className="ml-4">
                        <p className="mt-2 text-gray-600">
                          🌍 Une source de lumière indispensable Grâce à nos kits solaires, les foyers autrefois plongés dans l’obscurité disposent désormais d’un éclairage sûr et durable. Que ce soit pour permettre aux enfants d’étudier le soir, aux familles de cuisiner en toute tranquillité ou aux commerçants de prolonger leur activité, nos solutions apportent un véritable changement.
                        </p>
                        <p className="mt-2 text-gray-600">
                          ⚡ Une autonomie énergétique accessible à tous Nos lampes solaires sont faciles à installer et à utiliser. Comme illustré dans les images, elles fonctionnent sans électricité, avec une simple recharge solaire, offrant ainsi une indépendance énergétique totale, même dans les zones les plus reculées.e.
                        </p>
                      </div>
                    </motion.div>
                  </div>
                  <div ref={ref}>
                    <motion.div
                      variants={{
                        hidden: { opacity: 0, x: 75 },
                        visible: { opacity: 1, x: 0 },
                      }}
                      initial="hidden"
                      animate={mainControlls}
                      transition={{ duration: 0.5, delay: 0.25 }}
                      aria-hidden="true"
                      className="mt-10 lg:mt-0"
                    >
                      <img
                        src={image1}
                        alt="image1"
                        className="taos:translate-x-[200px] taos:opacity-0 hover:-translate-y-2 transition ease-in-out duration-300 hover:drop-shadow-xl mx-auto rounded-lg shadow-lg dark:bg-gray-500 border-4 border-blue-200"
                      />
                    </motion.div>
                  </div>
                </div>
                <div>
                  <div className="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
                    <div className="lg:col-start-2">
                      <div className="mt-12 space-y-12">
                        <motion.div
                          ref={ref}
                          variants={{
                            hidden: { opacity: 0, y: -75 },
                            visible: { opacity: 1, y: 0 },
                          }}
                          initial="hidden"
                          animate={mainControlls}
                          transition={{ duration: 0.5, delay: 0.55 }}
                          className="flex"
                        >
                          <div className="ml-4">
                          <p className="mt-2 text-gray-600">
                              💡 Économie et durabilité
                              Nos foyers améliorés réduisent de plus de 30 % la consommation de combustibles, tandis que nos kits solaires certifiés VERASOL sont garantis 24 mois, assurant une performance fiable et durable.
                            </p>
                            <p className="mt-2 text-gray-600">
                              ✅ Un engagement pour un avenir plus vert
                              En choisissant ETS ROSE, vous participez à la préservation de l’environnement tout en améliorant votre quotidien. Moins de bougies, moins de kérosène, plus de sécurité et un impact positif sur la planète !
                            </p>
                          </div>
                        </motion.div>
                      </div>
                    </div>
                    <motion.div
                      ref={ref}
                      variants={{
                        hidden: { opacity: 0, x: -75 },
                        visible: { opacity: 1, x: 0 },
                      }}
                      initial="hidden"
                      animate={mainControlls}
                      transition={{ duration: 0.5, delay: 0.15 }}
                      className="mt-10 lg:mt-0 lg:col-start-1 lg:row-start-1"
                    >
                      <img
                        src={image2}
                        alt="image2"
                        className="taos:translate-x-[200px] taos:opacity-0 hover:-translate-y-2 transition ease-in-out duration-300 hover:drop-shadow-xl mx-auto rounded-lg shadow-lg dark:bg-gray-500 border-4 border-blue-200"
                      />
                    </motion.div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}

        {/* end */}
      </div>
      <div className="flex justify-end ml-[30%] w-[70%] h-[2px] bg-gradient-to-r from-blue-400 to-violet-500"></div>
    </>
  );
};

export default Features;
